const COPY_BUTTON_SELECTOR = '.js-share-article-copy';
const INSTAGRAM_BUTTON_SELECTOR = '.js-share-article-instagram';
const COPIED_CLASS = 'is-copied';

/**
 * Copy text to clipboard with fallback for non-secure contexts.
 *
 * @param {string} text Text to copy.
 * @return {Promise<boolean>} True when copied.
 */
const copyText = async ( text ) => {

	if ( ! text ) {

		return false;

	}

	if ( navigator.clipboard && navigator.clipboard.writeText ) {

		try {

			await navigator.clipboard.writeText( text );
			return true;

		} catch ( error ) {

			// Continue to fallback below.

		}

	}

	const textarea = document.createElement( 'textarea' );
	textarea.value = text;
	textarea.setAttribute( 'readonly', '' );
	textarea.style.position = 'absolute';
	textarea.style.left = '-9999px';
	document.body.appendChild( textarea );
	textarea.select();

	let copied = false;
	try {

		copied = document.execCommand( 'copy' );

	} catch ( error ) {

		copied = false;

	}

	document.body.removeChild( textarea );
	return copied;

};

/**
 * Show temporary copied feedback on button.
 *
 * @param {HTMLElement} element Target button.
 * @return {void}
 */
const showCopiedState = ( element ) => {

	element.classList.add( COPIED_CLASS );

	setTimeout( () => {

		element.classList.remove( COPIED_CLASS );

	}, 1200 );

};

document.addEventListener( 'click', async ( event ) => {

	const copyButton = event.target.closest( COPY_BUTTON_SELECTOR );

	if ( copyButton ) {

		event.preventDefault();

		const url = copyButton.getAttribute( 'data-copy-url' );
		const copied = await copyText( url );

		if ( copied ) {

			showCopiedState( copyButton );

		}

		return;

	}

	const instagramButton = event.target.closest( INSTAGRAM_BUTTON_SELECTOR );

	if ( ! instagramButton ) {

		return;

	}

	event.preventDefault();

	const url = instagramButton.getAttribute( 'data-copy-url' );
	const instagramUrl = instagramButton.getAttribute( 'data-instagram-url' ) || 'https://www.instagram.com/';
	const copied = await copyText( url );

	if ( copied ) {

		showCopiedState( instagramButton );

	}

	window.open( instagramUrl, '_blank', 'noopener,noreferrer' );

} );
